import React from "react"
import { sanitizeRteContent } from "../utilities"
import DfbRte from "../ui-kit/dfb_rte"
import Section from "./section"
import DfbAnchor from "../ui-kit/dfb_anchor"
import DfbButton from "../ui-kit/dfb_button"

const MRichtext = (props) => {
  const sectionClasses =
    props.data.layout === "left" || props.data.layout === "right"
      ? `m-RichText--${props.data.layout}`
      : ""

  return (
    <Section
      baseClass="m-RichText"
      className={sectionClasses}
      defaultPadding="extra-small"
      data={props.data}
    >
      <div className="m-RichText-wrapper">
        <div className="m-RichText-container">
          <div className="m-RichText-content">
            {props.data.text && (
              <DfbRte text={sanitizeRteContent(props.data.text)} />
            )}
            {(props.data.anchor_obj?.url || props.data.assets?.src) && (
              <div className="m-RichText-button-group">
                {props.data.anchor_obj?.url && (
                  <DfbAnchor
                    tagName="a"
                    secondary={true}
                    link={props.data.anchor_obj}
                    text={props.data.anchor_obj.title || "Weiterlesen"}
                  />
                )}
                {props.data.assets?.src && (
                  <DfbButton
                    tagName="a"
                    text={props.data.assets.title || "Download"}
                    link={props.data.assets.src}
                  />
                )}
              </div>
            )}
          </div>
        </div>
      </div>
    </Section>
  )
}

export default MRichtext
